// The Beat interface: what a labeled run plays. Item C's reveal beat
// implements it; until then, placeholderBeat.js does.
//
//   const beat = createSomeBeat(stage)   build every display object up front
//   beat.name            string, recorded in run logs
//   beat.durationMs      nominal length of one play
//   beat.start(nowMs)    begin a play at this frame time
//   beat.step(nowMs)     advance to this frame time; return true when finished
//   beat.reset()         back to the idle pose
//   beat.destroy()
//
// step() runs inside the ticker callback on every recorded frame. It must not
// allocate (no new objects, arrays, closures or strings) or log.

const METHODS = ['start', 'step', 'reset', 'destroy']

export function assertBeat(beat) {
    for (const m of METHODS) {
        if (typeof beat?.[m] !== 'function') throw new Error(`beat is missing ${m}()`)
    }
    if (typeof beat.name !== 'string') throw new Error('beat.name must be a string')
    if (!(beat.durationMs > 0)) throw new Error('beat.durationMs must be > 0')
    return beat
}
